import {Interceptor, MethodInterceptor} from "@hybird/core/proxy";
import {DeviceProtocol, DeviceProtocolBeginSeal, DeviceProtocolOperation} from "@hybird/core/device/protocol";
import {getAllMethodNames} from "@hybird/core/lib";

export class DeviceInterceptor extends Interceptor {

  /**
   *@type{DeviceProtocol}
   */
  deviceProtocol;

  constructor(deviceProtocol) {
    super();
    this.deviceProtocol = deviceProtocol;
  }

  createProxy() {
  }

  get order() {
    return 50;
  }
}


export class DeviceMethodInterceptor extends MethodInterceptor {

  /**
   *@type{DeviceProtocol}
   */
  deviceProtocol;

  invoke({
           self, params, proceed, methodName
         }) {
    if (!this.isSupport(self) && !(this[this[methodName]] instanceof Function)) {
      return proceed();
    }

    const paramsArg = [proceed, self];

    for (let i = 0; i < params.length; i++) {
      paramsArg.push(params[i]);
    }

    return this[methodName].apply(this, paramsArg);
  }

  get deviceInfo() {
    return this.deviceProtocol.deviceInfo;
  }

  constructor(deviceProtocol) {
    super();
    this.deviceProtocol = deviceProtocol;
  }

  createProxy() {
  }

  get order() {
    return 50;
  }
}


export class DeviceProtocolDeviceMethodInterceptor extends DeviceMethodInterceptor {
  methodName = "equipmentLock"
  excludeMethodName = ["constructor", "invoke", "isSupport", "createProxy"];

  /**
   * @param deviceBeginSeal{DeviceProtocolBeginSeal} beginSeal
   * @return {boolean} 是否支持
   */
  isSupport(deviceBeginSeal) {
    return false;
  }

  createProxy() {
    const names = getAllMethodNames(this, this.excludeMethodName, DeviceMethodInterceptor);

    for (const i in names) {
      const methodName = names[i];

      if (DeviceProtocol
              .prototype[names[i]] instanceof Function) {
        this.deviceProtocol.addProxy(methodName, this);
      }
    }
  }
}

export class BeginSealDeviceMethodInterceptor extends DeviceMethodInterceptor {
  methodName = "equipmentLock"
  excludeMethodName = ["constructor", "invoke", "isSupport", "createProxy"];

  /**
   * @param deviceBeginSeal{DeviceProtocolBeginSeal} beginSeal
   * @return {boolean} 是否支持
   */
  isSupport(deviceBeginSeal) {
    return false;
  }

  createProxy() {
    const names = getAllMethodNames(this, this.excludeMethodName, DeviceMethodInterceptor);

    for (const i in names) {
      const methodName = names[i];

      if (DeviceProtocolBeginSeal
              .prototype[names[i]] instanceof Function) {
        this.deviceProtocol.addBeginSealProxy(methodName, this);
      }
    }
  }
}

export class OperationDeviceMethodInterceptor extends DeviceMethodInterceptor {
  methodName = "firmwareUpgrade"
  excludeMethodName = ["constructor", "invoke", "isSupport", "createProxy"];

  /**
   * @param deviceProtocolOperation{DeviceProtocolOperation} beginSeal
   * @return {boolean} 是否支持
   */
  isSupport(deviceProtocolOperation) {
    return false;
  }

  createProxy() {
    const names = getAllMethodNames(this, this.excludeMethodName, DeviceMethodInterceptor);

    for (const i in names) {
      const methodName = names[i];

      if (DeviceProtocolOperation
              .prototype[names[i]] instanceof Function) {
        this.deviceProtocol.addOperationProxy(methodName, this);
      }
    }
  }
}
